import { eDonHangViewChiTietActionsDefine } from "../../action-types/don-hang/IDonHangViewChiTietActions";
import { generateActions } from "../generateActions";

export const donHangViewChiTietAction = {
    ...generateActions(eDonHangViewChiTietActionsDefine, "DON_HANG_VIEW_CHI_TIET"),
}